import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import HerissonLogo from "@/components/HerissonLogo";
import { useAuth } from "@/lib/AuthContext";
import { Menu, X, LogOut, User } from "lucide-react";

const LINKS = [
  { to: "/public", label: "Accueil", emoji: "🏠" },
  { to: "/public/programme", label: "Programme", emoji: "🎪" },
  { to: "/public/ateliers", label: "Ateliers", emoji: "🎨" },
  { to: "/public/restauration", label: "Restauration", emoji: "🍔" },
  { to: "/public/tickets", label: "Billetterie", emoji: "🎟️" },
  { to: "/public/bracelet", label: "Bracelet", emoji: "🎁" },
  { to: "/public/infos", label: "Infos", emoji: "ℹ️" },
];

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#0a0a0b]/95 backdrop-blur border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/public" className="flex items-center gap-3" data-testid="public-header-logo">
          <HerissonLogo size="xs" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/public"}
              className={({ isActive }) =>
                `px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
                  isActive ? "bg-neutral-800 text-white" : "text-neutral-300 hover:text-white hover:bg-neutral-800/60"
                }`
              }
              data-testid={`nav-${l.to.replace("/", "") || "home"}`}
            >
              <span className="mr-1">{l.emoji}</span>{l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-2">
          {user ? (
            <>
              <Link to="/account" className="px-3 py-2 rounded-lg text-sm font-semibold text-neutral-200 hover:bg-neutral-800 inline-flex items-center gap-2" data-testid="btn-account">
                <User size={16} />{user.name}
              </Link>
              <button onClick={() => { logout(); nav("/public"); }} className="px-3 py-2 rounded-lg text-sm text-neutral-400 hover:text-white inline-flex items-center gap-2" data-testid="btn-logout">
                <LogOut size={16} />Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="px-3 py-2 rounded-lg text-sm font-semibold text-neutral-200 hover:bg-neutral-800" data-testid="btn-login">Se connecter</Link>
              <Link to="/register" className="brand-gradient-btn px-4 py-2 rounded-lg text-sm" data-testid="btn-register">Créer un compte</Link>
            </>
          )}
        </div>
        <button className="lg:hidden p-2 text-neutral-200" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="btn-mobile-menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-neutral-800 bg-[#0a0a0b] px-4 py-3 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/public"} onClick={() => setOpen(false)}
              className={({ isActive }) => `block px-3 py-2 rounded-lg font-semibold ${isActive ? "bg-neutral-800 text-white" : "text-neutral-300"}`}>
              <span className="mr-2">{l.emoji}</span>{l.label}
            </NavLink>
          ))}
          <div className="pt-2 border-t border-neutral-800 mt-2">
            {user ? (
              <>
                <Link to="/account" onClick={() => setOpen(false)} className="block px-3 py-2 text-neutral-200">👤 Mon compte ({user.name})</Link>
                <button onClick={() => { logout(); setOpen(false); nav("/public"); }} className="block w-full text-left px-3 py-2 text-neutral-400">Déconnexion</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="block px-3 py-2 text-neutral-200">🔑 Se connecter</Link>
                <Link to="/register" onClick={() => setOpen(false)} className="block px-3 py-2 text-neutral-200">✨ Créer un compte</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
